import { render, staticRenderFns } from "./ProductLinkEcharts.vue?vue&type=template&id=54f06106"
import script from "./ProductLinkEcharts.vue?vue&type=script&lang=js"
export * from "./ProductLinkEcharts.vue?vue&type=script&lang=js"
import style0 from "./ProductLinkEcharts.vue?vue&type=style&index=0&id=54f06106&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports